module.exports = __webpack_public_path__ + "static/media/Amealio_Illustrations-02.76de04d7.svg";